<template>
  <div class="language-switcher">
    <div class="lang-item" 
         :class="{ active: currentLang === 'zh' }" 
         @click="switchLang('zh')">
      简
    </div>
    <div class="lang-item" 
         :class="{ active: currentLang === 'zh-TW' }" 
         @click="switchLang('zh-TW')">
      繁
    </div>
    <div class="lang-item" 
         :class="{ active: currentLang === 'en' }" 
         @click="switchLang('en')">
      EN
    </div>
  </div>
</template>

<script>
import { setup } from '../../../i18n/i18n'

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      currentLang: 'zh'
    }
  },
  created() {
    // 从 localStorage 获取语言设置
    const savedLang = window.localStorage.getItem('localeLanguage')
    if (savedLang && ['zh', 'zh-TW', 'en'].includes(savedLang)) {
      this.currentLang = savedLang
      setup(savedLang)
    }
  },
  methods: {
    switchLang(lang) {
      this.currentLang = lang
      setup(lang)
      // 触发语言切换事件，通知父组件刷新数据
      this.$emit('lang-change', lang)
    }
  }
}
</script>

<style scoped>
.language-switcher {
  display: flex;
  align-items: center;
  gap: 2px;
  margin-left: auto;
  padding-right: 10px;
  min-width: 120px;
  justify-content: flex-end;
}

.lang-item {
  padding: 4px 8px;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  border-radius: 3px;
  transition: all 0.3s ease;
  user-select: none;
}

.lang-item:hover {
  color: #333;
  background-color: #f5f5f5;
}

.lang-item.active {
  color: #fff;
  background-color: #1a73e8;
}

/* 移动端适配 */
@media (max-width: 768px) {
  .language-switcher {
    margin-left: 0;
    margin-top: 30px;
    justify-content: center;
    padding-bottom: 20px;
  }
  
  .lang-item {
    padding: 8px 16px;
    font-size: 14px;
    color: #fff;
  }
  
  .lang-item:hover {
    color: #fff;
    background-color: rgba(255,255,255,0.2);
  }
  
  .lang-item.active {
    color: #fff;
    background-color: #e60012;
  }
}
</style>
